import { BarChart, Bar, XAxis, Cell, CartesianGrid, YAxis, ResponsiveContainer } from 'recharts'
import { OCCUPANCY_STATUSES } from '../constants'

const LiveOccupancyCharts = ({ dayUsageStats }) => (
    <ResponsiveContainer className="mt-4" width="100%" minHeight={300}>
        <BarChart height={300} data={dayUsageStats} fill="#f5a623">
            <XAxis dataKey="hourEnd" axisLine={false} tickLine={false} fontSize="12px" />
            <YAxis hide={true} type="number" domain={[0, 1]} />
            <CartesianGrid strokeDasharray="2 2" />
            <Bar fill="#f5a623" dataKey="usagePercentage" barSize={30}>
                {dayUsageStats.map(({ status }, index) => (
                    <Cell fill={OCCUPANCY_STATUSES[status.toLowerCase()].colorCode} key={index} radius={1} />
                ))}
            </Bar>
        </BarChart>
    </ResponsiveContainer>
)

export default LiveOccupancyCharts
